export { default as Home } from './Home/Home'
export { default as Contact } from './Contact/Contact'
export { default as CookiePolicy } from './CookiePolicy/CookiePolicy'
export { default as Imprint } from './Imprint/Imprint'
export { default as PrivacyPolicy } from './PrivacyPolicy/PrivacyPolicy'
export { default as Careers } from './Careers/Careers'
export { default as Custom01 } from './Custom_01/Custom_01'
export { default as Custom02 } from './Custom_02/Custom_02'
export { default as Custom03 } from './Custom_03/Custom_03'
export { default as Custom04 } from './Custom_04/Custom_04'